import { computed, ref } from 'vue'
import { useVuelidate } from '@vuelidate/core'

// TODO: Add typescript
// @ts-ignore
export const useValidation = (validations, state) => {
  const v$ = useVuelidate(validations, state)
  //TODO: Temporary any, for a success build
  const errors = ref<any>(
    Object.entries(state).reduce((result, [key]) => {
      // @ts-ignore
      result[key] = computed(() => v$.value[key]?.$errors.map(({ $message }) => $message))
      return result
    }, {})
  )
  return {
    v$,
    errors,
  }
}
